import { useLocation, Navigate } from "react-router-dom";
import { LogIn, Shield, ShoppingBag, Factory } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/AuthProvider";

export default function Login() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F1E8]">
        <div className="text-sm text-[#6C757D]">Loading…</div>
      </div>
    );
  }
  if (user) {
    return <Navigate to="/" replace />;
  }

  const error = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F7F1E8] flex items-center justify-center px-4 py-8" data-testid="page-login">
      <div className="card-soft p-8 sm:p-10 max-w-md w-full flex flex-col items-center gap-6 text-center">
        <img src="/garnacha-logo.svg" alt="Garnacha" className="w-20 h-20 object-contain" draggable={false} />
        <div>
          <div className="brand-overline">Garnacha System</div>
          <h1 className="font-display font-bold text-3xl text-[#222] mt-1">Garnacha Horeca</h1>
          <p className="text-sm text-[#6C757D] mt-2">
            Sign in with your authorized Google account to access leads, samples, orders and traceability.
          </p>
        </div>

        <Button
          onClick={handleLogin}
          className="w-full bg-[#E85D04] hover:bg-[#c94b03] text-white h-11"
          data-testid="google-login-btn"
        >
          <LogIn size={18} className="mr-2" /> Sign in with Google
        </Button>

        {error && (
          <div className="text-sm text-[#E76F51] bg-[#E76F51]/10 px-3 py-2 rounded-lg w-full" data-testid="login-error">
            {error}
          </div>
        )}

        <div className="w-full border-t border-[#E5E5E5] pt-5">
          <div className="brand-overline mb-3">Roles</div>
          <div className="grid grid-cols-3 gap-2 text-[10px] uppercase tracking-wider">
            <RoleChip icon={Shield} label="Admin" color="#E85D04" />
            <RoleChip icon={ShoppingBag} label="Sales" color="#457B9D" />
            <RoleChip icon={Factory} label="Production" color="#7B6DCC" />
          </div>
        </div>

        <div className="text-[10px] tracking-[0.22em] uppercase text-[#1F4D3A] font-semibold pt-2">
          DRIP IT. DIP IT. <span className="text-[#E85D04]">LOVE IT.™</span>
        </div>
      </div>
    </div>
  );
}

const RoleChip = ({ icon: Icon, label, color }) => (
  <div className="rounded-lg p-2 border flex flex-col items-center gap-1"
       style={{ backgroundColor: `${color}0d`, borderColor: `${color}33`, color }}>
    <Icon size={14} />
    <span className="font-bold">{label}</span>
  </div>
);
